function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  id: "Layer_x0020_1"
}, React.createElement("metadata", {
  id: "CorelCorpID_0Corel-Layer"
}), React.createElement("path", {
  id: "Shape",
  className: "fil0",
  d: "M203645 43728l21725 -18626c5804,-5230 6376,-14127 1302,-20061 -5080,-5933 -13962,-6741 -20021,-1814l-50401 43201c-3198,2736 -5033,6730 -5033,10936 0,4206 1835,8203 5033,10939l50401 43201c3885,3505 9370,4625 14318,2922 4949,-1698 8586,-5949 9499,-11101 916,-5155 -1036,-10397 -5098,-13696l-19519 -16725c84475,10008 145961,84956 139276,169760 -6694,84807 -79167,149185 -164168,145826 -85001,-3353 -152175,-73251 -152157,-158319 -132,-35639 11884,-70260 34067,-98152 3266,-4032 4117,-9505 2219,-14339 -1895,-4826 -6245,-8263 -11382,-8990 -5137,-731 -10265,1359 -13433,5472 -26221,32963 -40423,73886 -40270,116009 -24,101260 80478,184187 181696,187168 101214,2982 186458,-75062 192397,-176145 5937,-101089 -69578,-188575 -170448,-197466l-3 0zm-90596 67776c3885,3505 9367,4625 14315,2922 4952,-1698 8586,-5949 9502,-11101 913,-5155 -1039,-10397 -5098,-13696l-37636 -32265 37636 -32262c5801,-5230 6379,-14127 1299,-20061 -5077,-5933 -13956,-6741 -20018,-1814l-50404 43201c-3197,2736 -5033,6730 -5033,10936 0,4206 1836,8203 5033,10939l50404 43201zm159455 115357l-66590 38447 -66593 38447 0 -76894 0 -76895 66593 38447 66590 38448z"
}));

var SvgCatchUp = function SvgCatchUp(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    xmlSpace: "preserve",
    width: "12.5074mm",
    height: "13.9437mm",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    viewBox: "0 0 374426 417423",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgCatchUp, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/catchUp.70c51ee7.svg";
export { ForwardRef as ReactComponent };